import axios from 'axios';

import BaseService from "./BaseService";
import LogUtils from "../utils/LogUtils";
import settings from "../settings/settings";

class GeoLocationService extends BaseService {

  constructor() {
    super();
    this.TAG = "GeoLocationService";

    this.logUtils = new LogUtils();
  }

  async getGeoLocation(geoLocationId) {
    let geoLocation = {};

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/geo-locations?id=${geoLocationId}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar a geolocalização."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar a geolocalização."
        };
      }

      geoLocation = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getGeoLocation", err);

      return {
        status: -2,
        msg: "Não foi possível retornar a geolocalização"
      };
    }

    return {
      status: 1,
      msg: "A geolocalização foi retornada com sucesso.",
      data: geoLocation
    };
  }

  async getGeoLocationByLatLng({lat, lng}) {
    let geoLocation = {};

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/geo-locations?lat=${lat}&lng=${lng}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar a geolocalização."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar a geolocalização."
        };
      }

      geoLocation = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getGeoLocation", err);

      return {
        status: -2,
        msg: "Não foi possível retornar a geolocalização"
      };
    }

    return {
      status: 1,
      msg: "A geolocalização foi retornada com sucesso.",
      data: geoLocation
    };
  }

  async createGeoLocation({creatorId, lat, lng, bounds, description}) {
    let newGeoLocation = null;

    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.POST,
          `${settings.MANAGEMENT_SERVICE_URL}/geo-locations`,
          this.getDefaultHeaders(true, true),
          {
            "creatorId": creatorId,
            "lat": lat,
            "lng": lng,
            "bounds": bounds,
            "geojson": null,
            "description": description
          },
          true
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível criar a geolocalização."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

      newGeoLocation = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to createGeoLocation", err);

      return {
        status: -2,
        msg: "Não foi possível criar a geolocalização"
      };
    }

    return {
      status: 1,
      msg: "Geolocalização criada com sucesso.",
      data: newGeoLocation
    };
  }

  async updateGeoLocation(geoLocationInfo) {
    let updatedGeoLocation = null;

    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.PUT,
          `${settings.MANAGEMENT_SERVICE_URL}/geo-locations/`,
          this.getDefaultHeaders(true),
          geoLocationInfo
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível atualizar a geolocalização."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

      updatedGeoLocation = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to updateGeoLocation", err);

      return {
        status: -2,
        msg: "Não foi possível atualizar a geolocalização"
      };
    }

    return {
      status: 1,
      msg: "Geolocalização atualizada com sucesso.",
      data: updatedGeoLocation
    };
  }

  async upsertGeoLocation({ creatorId, lat, lng, bounds, description }) {
    const resOpGeolocation = await this.getGeoLocationByLatLng({ lat, lng });
    const geoLocation = resOpGeolocation?.data;

    if (geoLocation) {
      geoLocation.description = description;
      return await this.updateGeoLocation(geoLocation);
    } else {
      return await this.createGeoLocation({ creatorId, lat, lng, bounds, description });
    }
  }

  async deleteGeoLocation(geoLocationInfo) {
    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.DELETE,
          `${settings.MANAGEMENT_SERVICE_URL}/geo-locations/`,
          this.getDefaultHeaders(true),
          geoLocationInfo
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível deletar a geolocalização do agente."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to deleteGeoLocation", err);

      return {
        status: -2,
        msg: "Não foi possível deletar a geolocalização."
      };
    }

    return {
      status: 1,
      msg: "Geolocalização deletada com sucesso."
    };
  }

}

export default GeoLocationService;